import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps, useRouteMatch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ICodeReq } from '../../../models/codes.model'
import { doGetCode, doUpdateCode } from '../../../store/code.slice';
import { doGetCommonCodes } from '../../../store/commonCode.slice';
import { doRemoveAuth } from '../../../store/auth.slice';
import { RootState } from '../../../store/rootReducer';
import { useSnackbar } from 'notistack';

import Loader from '../../../components/Loader';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import Footer from '../../../components/layout/Footer';
import Editor from '../../../components/system/code/Editor';
import { errorVariant, successVariant, warningVariant } from '../../../lib/barVariant';

interface IMatch {
  id: string;
}

const SystemCodeEdit: FC<RouteComponentProps> = ({
  history,
  location,
}) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const { code, isLoading } = useSelector((state: RootState) => state.code);
  const { isLoading: commonCodeLoading } = useSelector((state: RootState) => state.commonCode);

  const match = useRouteMatch<IMatch>();
  const id = String(match.params.id);

  useEffect(() => {
    getCode(id);
  }, [])

  const getCode = async (id: string) => {
    const res = await dispatch(doGetCode(id));

    switch (res?.status) {
      case 200:
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }

  const onSubmit = async (req: ICodeReq) => {
    const res = await dispatch(doUpdateCode(id, req));
    
    switch (res?.status) {
      case 200:
        dispatch(doGetCommonCodes());
        enqueueSnackbar(t('common.message.edit'), successVariant);
        history.push(`/system/code${location.search}`);
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }

  return (
    <div className="content scrollbar">
      {isLoading || commonCodeLoading ? <Loader /> : null}
      <SimpleHeader
        parentMenu={t('common.menu.system')}
        currentMenu={t('system.code.title3')}
      />
      <Editor
        code={code || null}
        onSubmit={onSubmit}
        cancelPath={null}
      />
      <Footer />
    </div>
  )
}

export default SystemCodeEdit;
